import QrScanner from "react-qr-scanner";
import { useNavigate } from "react-router-dom";
export default function QRScanner({ isqrenabled = false, ...props }) {
  const maskNumber = (num) => {
    const parts = num.split("-");
    const maskedParts = parts.map((part, index) =>
      index === parts.length - 1 ? part : part.replace(/./g, "X")
    );
    return maskedParts.join("-");
  };

  const navigate = useNavigate(); // React Router hook for navigation
  const handleScan = (data) => {
    if (data) {
      const qrData = JSON.parse(data.text);
      let dob = qrData.dob;
      let [day, month, year] = dob.split("-");
      let formattedDate = `${year}-${month}-${day}`;
      let yearOfBirth = new Date(formattedDate).getFullYear();
      const qrScanData = {
        name: qrData.name,
        abhaNo: maskNumber(qrData.hidn),
        originalabha: qrData.hidn,
        address: qrData.address,
        mobile: qrData.mobile.slice(0, -4).replace(/./g, "X") + qrData.mobile.slice(-4),
        originalmobile: qrData.mobile,
        dob: qrData.dob,
        yearOfBirth: 'XX-XX-' + yearOfBirth,
        gender: (qrData.gender == 'M') ? 'Male' : (qrData.gender == 'F') ? 'Female' : 'Other',
        kycphoto: (qrData.gender == 'M') ? "/images/male.svg" : (qrData.gender == 'F') ? "/images/female.svg" : "/images/male.svg",
        hid: qrData.hid,
        hidn: qrData.hidn,
        profilePhoto: qrData?.profilePhoto || null,
        preferredAbhaAddress: qrData?.preferredAbhaAddress || null,
        email: qrData?.email || null,
        abhaNumber: qrData?.ABHANumber || null,
        districtlgd: qrData?.districtCode || null,
        statelgd: qrData?.stateCode || null,
      };
      localStorage.setItem("beneficiaryDetails", JSON.stringify(qrScanData));
      localStorage.setItem("orignalBeneficiaryData", JSON.stringify(qrData));
      localStorage.removeItem("NCD_Searchdetails");
      localStorage.removeItem("NIKSHAY_Registration_Detials");
      localStorage.removeItem("NIKSHAY_NEW_PROFILE");
      navigate("/detailsabha");
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  return (isqrenabled === true ?
    <div className="qr-modal">
      <QrScanner
        delay={300}
        onError={handleError}
        onScan={handleScan}
        facingMode="environment"
        resolution={600}
        style={{
          width: "100%", // Matches the modal's width
          maxWidth: "100%", // Optional: Constrain the width if necessary
          height: "600px", // Maintain aspect ratio
        }}
      />

    </div>
    : null
  );
}